import { Button } from '@/components/shadcn/button'
import { IconDeleteOutline } from '@icons/IconDeleteOutline'
import { IconDownloadOutline } from '@icons/IconDownloadOutline'
import { MessagesStorageStorageDetailItemWorkspace } from './workspaceFilesTableUtils'
import { downloadFile } from '../../Forms/FilesList/downloadFile'
import { useCurrentWorkspace } from '../../useCurrentWorkspace'
import { useRestClient } from '@/contexts/QueryProvider'
import { MessagesStorageStorageFileType } from '@/util/enums'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { toast } from 'sonner'

export function RowActionButtons({ item }: { item: MessagesStorageStorageDetailItemWorkspace }) {
  const { workspaceId } = useCurrentWorkspace()
  const { getStorageApiGetFilesDetailsWorkspace, postStorageApiDeleteFileWorkspace } = useRestClient()

  const { mutate: deleteFile, isPending: isDeleteFilePending } = postStorageApiDeleteFileWorkspace.useMutation()

  const invalidateFiles = () =>
    getStorageApiGetFilesDetailsWorkspace.invalidateQueries({
      parameters: { query: { workspaceId } },
    })

  const onDeleteClick = async (f: MessagesStorageStorageDetailItemWorkspace) => {
    deleteFile(
      {
        query: {
          blobName: f.encryptedBlobName,
          subscriptionId: workspaceId,
          fileType: MessagesStorageStorageFileType.Template,
        },
      },
      {
        onSuccess: () => {
          toast.success('File deleted.')
          invalidateFiles()
        },
        onError: () => {
          toast.error('File was not deleted.')
        },
      }
    )
  }

  return (
    <div className="flex w-full justify-end">
      <Button variant="ghost" size="icon" onClick={() => downloadFile(item, workspaceId)}>
        <IconDownloadOutline />
      </Button>
      <ConfirmDialog
        trigger={
          // <Button disabled={!isDeleteFileAllowed || isDeleteFilePending} variant="ghost" size="icon">
          <Button disabled={isDeleteFilePending} variant="ghost" size="icon">
            <IconDeleteOutline />
          </Button>
        }
        onConfirm={() => onDeleteClick(item)}
        title="Delete file"
        description="Are you sure you want to delete the file?"
      />
    </div>
  )
}
